/**
 * Created by ricardocabret on 8/10/16.
 */
angular.module('eStories.upload', [
        'eStories.uploader.model'
    ])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.upload', {
                url: 'upload',
                views: {
                    'mainView@': {
                        controller: 'LibraryCtrl as libraryCtrl',
                        templateUrl: 'uploader/upload.tmpl.html'
                    }
                }
            })
    }])

    .controller('UploadCtrl', [
        '$uibModalInstance',
        'UploadModel',
        '$rootScope',
        'ModalsModel',
        '$scope',
        '$state',
        'LL',
        '$location',
        'GA',
        function ($uibModalInstance, UploadModel, $rootScope, ModalsModel, $scope, $state, LL, $location, GA) {

            var uploadCtrl = this;

            GA.trackPageView($location.path());

            $scope.$on('uploadComplete', function (e) {
                uploadCtrl.closeUploadModal();
//              if upload confirm modal is there, do not show it again
                if (!UploadModel.alreadyShowingUploadConfirmation) {
                    UploadModel.alreadyShowingUploadConfirmation = true;

                    if (UploadModel.failedFiles) {
                        UploadModel.errorMessage = "Sorry, " + String(UploadModel.failedFiles) + " MP3 " +
                                                    (UploadModel.failedFiles > 1 ? 'files' : 'file') +
                                                   " cannot be uploaded. Only audiobooks with an 'Audiobook' genre can be uploaded. " +
                                                   "Please update the genre of your files if you wish to continue uploading " +
                                                   "to your Audiobook Library.";
                    }
                    var thisModal = ModalsModel.open("/uploader/uploadConfirmation.tmpl.html", 'UploadCtrl', 'uploadCtrl', null, null);

                    var thisModalClosed = function () {
                        UploadModel.resetUploader();
                        UploadModel.alreadyShowingUploadConfirmation = false;
                        UploadModel.failedFiles = 0;
                        UploadModel.successfulFiles = 0;
                        UploadModel.errorMessage = null;
                    };
                    thisModal.result.then(thisModalClosed, thisModalClosed);
                }
            });

            uploadCtrl.closeUploadModal = function () {
                $uibModalInstance.close();
            };

            uploadCtrl.uploadModel = UploadModel;

            uploadCtrl.cancelUpload = function () {
                $rootScope.$broadcast('resetDropzone')
            };
        }]);
